module.exports = __webpack_public_path__ + "static/media/15423189010012024216509 - Citizen Datasteward.2e1b3347.jpg";